(function () {
  function getViolationsFromDom() {
    const violations = [];

    document.querySelectorAll('.cart-item[data-minimum-quantity]').forEach((row) => {
      const minimum = parseInt(row.dataset.minimumQuantity, 10);
      const line = parseInt(row.dataset.line, 10);
      const title = row.dataset.productTitle || '';
      const input = row.querySelector('.quantity__input');
      const quantity = parseInt(input?.value, 10);

      if (!minimum || minimum <= 1 || !line || !quantity) return;
      if (quantity < minimum) {
        violations.push({ line, minimum, quantity, title });
      }
    });

    return violations;
  }

  async function getViolationsFromCart() {
    const response = await fetch(`${window.routes.cart_url}.js`);
    if (!response.ok) return [];

    const cart = await response.json();
    const violations = [];

    cart.items.forEach((item, index) => {
      const minimum = parseInt(item.properties?._minimum_quantity, 10);
      if (!minimum || minimum <= 1) return;

      if (item.quantity < minimum) {
        violations.push({
          line: index + 1,
          minimum,
          quantity: item.quantity,
          title: item.product_title,
        });
      }
    });

    return violations;
  }

  async function getViolations() {
    const cartViolations = await getViolationsFromCart();
    if (cartViolations.length) return cartViolations;

    return getViolationsFromDom();
  }

  function getMinimumQuantityFromForm(form) {
    const propertyInput = form.querySelector('[name="properties[_minimum_quantity]"]');
    const quantityInput = form.elements.quantity || form.querySelector('[name="quantity"]');
    const minimum = parseInt(
      quantityInput?.dataset?.minimumQuantity || quantityInput?.min || propertyInput?.value,
      10
    );

    return Number.isNaN(minimum) ? 0 : minimum;
  }

  function applyMinimumQuantityToFormData(form, formData) {
    const minimum = getMinimumQuantityFromForm(form);
    if (!minimum || minimum <= 1) return formData;

    const quantityInput = form.elements.quantity || form.querySelector('[name="quantity"]');
    const currentQuantity = parseInt(formData.get('quantity') || quantityInput?.value, 10);

    if (!formData.get('quantity') || Number.isNaN(currentQuantity) || currentQuantity < minimum) {
      formData.set('quantity', minimum);
    }

    if (quantityInput && parseInt(quantityInput.value, 10) < minimum) {
      quantityInput.value = minimum;
    }

    if (!formData.get('properties[_minimum_quantity]')) {
      formData.set('properties[_minimum_quantity]', minimum);
    }

    return formData;
  }

  function showCartError(message) {
    const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
    if (!errors) return;
    errors.textContent = message;
    errors.style.display = 'block';
  }

  async function fixViolations(violations) {
    for (const violation of violations) {
      const response = await fetch(window.routes.cart_change_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          line: violation.line,
          quantity: violation.minimum,
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to update cart');
      }
    }
  }

  async function fetchCartSections(cartComponent) {
    if (!cartComponent?.getSectionsToRender) return null;

    const sectionIds = cartComponent.getSectionsToRender().map((section) => section.id).join(',');
    const response = await fetch(`${window.shopUrl}?sections=${sectionIds}`);

    if (!response.ok) return null;

    return response.json();
  }

  async function ensureValidCart({ reload = false } = {}) {
    const violations = await getViolations();
    if (!violations.length) return true;

    try {
      await fixViolations(violations);

      if (reload) {
        window.location.reload();
        return false;
      }

      return true;
    } catch (error) {
      showCartError(window.cartStrings.error);
      return false;
    }
  }

  async function afterCartAdd(cartComponent, addResponse) {
    if (!cartComponent) return addResponse;

    let violations = await getViolationsFromCart();
    if (!violations.length) return addResponse;

    try {
      await fixViolations(violations);

      const sections = await fetchCartSections(cartComponent);
      if (!sections) return addResponse;

      return {
        ...addResponse,
        sections: {
          ...addResponse.sections,
          ...sections,
        },
      };
    } catch (error) {
      showCartError(window.cartStrings.error);
      return addResponse;
    }
  }

  function enforceInputMinimum(input) {
    if (!input) return input;

    const minimum = parseInt(input.dataset.minimumQuantity || input.min, 10);
    const quantity = parseInt(input.value, 10);

    if (!minimum || minimum <= 1 || Number.isNaN(quantity)) return input;

    if (quantity > 0 && quantity < minimum) {
      input.value = minimum;
    }

    return input;
  }

  function validateProductFormQuantity(form) {
    applyMinimumQuantityToFormData(form, new FormData(form));
    return true;
  }

  function bindCheckoutValidation() {
    document.addEventListener(
      'click',
      async (event) => {
        const checkoutButton = event.target.closest('[name="checkout"]');
        if (!checkoutButton || checkoutButton.disabled) return;

        const violations = await getViolations();
        if (!violations.length) return;

        event.preventDefault();
        event.stopPropagation();

        const isValid = await ensureValidCart();
        if (!isValid) return;

        window.location.href = `${window.shopUrl}/checkout`;
      },
      true
    );

    document.addEventListener(
      'submit',
      async (event) => {
        const form = event.target;
        if (!(form instanceof HTMLFormElement)) return;

        const checkoutSubmitter = event.submitter?.getAttribute('name') === 'checkout';
        const checkoutField = form.querySelector('[name="checkout"]');
        if (!checkoutSubmitter && !checkoutField) return;

        const violations = await getViolations();
        if (!violations.length) return;

        event.preventDefault();
        event.stopPropagation();

        const isValid = await ensureValidCart();
        if (!isValid) return;

        window.location.href = `${window.shopUrl}/checkout`;
      },
      true
    );
  }

  function bindCartUpdateValidation() {
    if (typeof subscribe !== 'function') return;

    subscribe(PUB_SUB_EVENTS.cartUpdate, async (event) => {
      if (event?.source === 'cart-minimum-quantity') return;

      const violations = await getViolationsFromCart();
      if (!violations.length) return;

      const cartComponent = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      if (!cartComponent) return;

      try {
        await fixViolations(violations);
        const sections = await fetchCartSections(cartComponent);
        if (!sections || typeof cartComponent.renderContents !== 'function') return;

        cartComponent.renderContents({
          sections,
        });

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-minimum-quantity' });
      } catch (error) {
        showCartError(window.cartStrings.error);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', async () => {
    bindCheckoutValidation();
    bindCartUpdateValidation();

    const violations = await getViolations();
    if (violations.length) {
      ensureValidCart({ reload: true });
    }
  });

  window.CartMinimumQuantity = {
    getViolations,
    ensureValidCart,
    afterCartAdd,
    applyMinimumQuantityToFormData,
    enforceInputMinimum,
    validateProductFormQuantity,
  };
})();
